import toonShade from "../snippets/toonShade";

export default `
precision highp float;

varying vec2 vUv;
varying mat3 vNormalMatrix;
varying vec3 vWorldPosition;

varying float vHexagonTilingIndex;
varying float vHexFlag0;
varying float vHexFlag1;
varying float vHexFlag2;
varying float vHexFlag3;
varying float vHexFlag4;
varying float vHexFlag5;

uniform float aspect;
uniform sampler2D heightmap;
uniform sampler2D normalMap;

uniform sampler2D texture;

uniform vec2 center;
uniform vec2 hexTextureUVOffset;
uniform float radius;

uniform vec4 tint;
uniform float antigenIntensity;
uniform vec3 antigenColor;

uniform vec2 lightPos;

#define PI 3.1415926538
#define SixtyDegrees 1.0472


void main() {

	//Determine which texture to use
	//if(vUv != center) {
		//Find angle around center of shape
		//Transform stretched coordinates to uniform for angle
		vec2 localUv = vec2(vUv.x * aspect, vUv.y);
		vec2 localcenter = vec2(center.x * aspect, center.y);
		vec2 fromCenter = localUv - localcenter;
		float distanceToCenter = 1.0 - min(1.0, (length(fromCenter) / (radius * aspect)));
		fromCenter = normalize(fromCenter);
		vec2 xAxis = normalize(vec2(1.0, localcenter.y) - localcenter);
		float angle = acos(dot(xAxis, fromCenter));
		if(fromCenter.y > 0.0) angle = (2.0 * PI) - angle; 

		//Choose to use a hexagonal piece if flag from game says to.
		int sideIndex = int(floor(angle/SixtyDegrees));

		//Can't actually dependent index array, so do this trash
		vec2 uv = vUv;
		uv = uv + hexTextureUVOffset * vHexFlag0 * (sideIndex == 0 ? 1.0 : 0.0);
		uv = uv + hexTextureUVOffset * vHexFlag1 * (sideIndex == 1 ? 1.0 : 0.0);
		uv = uv + hexTextureUVOffset * vHexFlag2 * (sideIndex == 2 ? 1.0 : 0.0);
		uv = uv + hexTextureUVOffset * vHexFlag3 * (sideIndex == 3 ? 1.0 : 0.0);
		uv = uv + hexTextureUVOffset * vHexFlag4 * (sideIndex == 4 ? 1.0 : 0.0);
		uv = uv + hexTextureUVOffset * vHexFlag5 * (sideIndex == 5 ? 1.0 : 0.0);
	//}

	vec4 color = texture2D(texture, uv);
	//Blend towards the center so there isn't a hard cut in normal map
	vec4 circleColor = texture2D(texture, vUv);
	color = mix(color, circleColor, distanceToCenter);
	
	//Get light posiition
	vec3 lightPosition = vec3(lightPos, 1000); //need a z-dimension for the lighting in "pixels"
	vec3 lightDirection = normalize(lightPosition - vWorldPosition);

	vec4 normalMapValue = texture2D(normalMap, vUv);
	vec3 normal = normalize(normalMapValue.xyz * 2.0 - 1.0);
	normal = normalize(vNormalMatrix * normal);

	//Ambient lighting
	float ambientScaler = 0.40; //TODO: There is def something wrong with these balances/way this works.
	vec3 ambientColor = vec3( ambientScaler ); //TODO: Pass this in

	//Diffuse lighting
	float diffuseLight = max(dot(normal, lightDirection), 0.0);
	float diffuseScaler = 0.75;
	vec3 diffuseColor = vec3( vec3(diffuseScaler) * diffuseLight);

	//Specular lighting
	float specularScaler = 0.5;
	float shininess = 16.0;
	vec3 cameraPos = vec3(vWorldPosition.x, vWorldPosition.y, -10.0);
	vec3 viewDir = normalize(cameraPos - vWorldPosition);
	//Confusuin here, sources say you are supposed to invert vLightDir, but I get wrong result if I do..
	vec3 reflectDir = reflect(lightDirection, normal);
	float spec = pow(max(dot(viewDir, reflectDir), 0.0), shininess);
	vec3 specularColor = specularScaler * spec * color.xyz;

	//Regular Phong lighting
	vec3 litColor = (color.xyz * (diffuseColor + ambientColor + specularColor));
	vec3 result = litColor.xyz;

	//Toon shading
	vec3 toonColor = result.xyz;
	//vec3 result;
	${toonShade('toonColor', 'diffuseLight', 'spec', 'result')}

	//Apply tint
	result = mix(result.rgb, tint.rgb, tint.a);

	gl_FragColor = vec4(result, color.a);
}
`
